/* eslint-disable import/prefer-default-export */
import ApiService from '@/services/ApiService';
import store from '@/store/store';

class MessengerService {
  static async getUserData() {
    const tokkoChatHost = localStorage.getItem('tokkoChatHost');
    const composedURL = `${tokkoChatHost}/authorize/oauth`;
    const requestOptions = {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('jwt'),
      },
    };

    const response = await fetch(composedURL, requestOptions);
    if (!response.ok) {
      throw new Error(response.message || 'Request failed');
    }

    const data = await response.json();

    return data;
  }

  static async getAgentPermission(id) {
    const composedURL = `/api3/users/permissions?user_id=${id}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getUserContacts(
    searchQuery,
    reachedEndOfScroll,
    withColleagues
  ) {
    const { accessToken } = store.getState().MessengerSlice.data;
    const { tokkoMessengerURL } = store.getState().UserPreferencesSlice;
    return fetch(
      `${tokkoMessengerURL}/users/me/contacts?objects_per_page=10&page=${reachedEndOfScroll}&word=${searchQuery}&colleagues=${withColleagues}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => data)
      .catch((error) => {
        throw error;
      });
  }

  // eslint-disable-next-line camelcase
  static async postUserData(name, email, image, cellphone_number) {
    const { accessToken } = store.getState().MessengerSlice.data;
    const { tokkoMessengerURL } = store.getState().UserPreferencesSlice;

    const bodyContent = JSON.stringify({
      name,
      email,
      image,
      cellphone_number,
    });
    return fetch(`${tokkoMessengerURL}/users/me`, {
      method: 'POST',
      credentials: 'include',
      body: bodyContent,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .catch((error) => {
        throw error;
      });
  }

  static async sentProdMessage(data) {
    const { accessToken } = store.getState().MessengerSlice.data;
    const { tokkoMessengerURL } = store.getState().UserPreferencesSlice;

    const bodyContent = JSON.stringify(data);

    return fetch(`${tokkoMessengerURL}/users/me/messages/new`, {
      method: 'POST',
      credentials: 'include',
      body: bodyContent,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .catch((error) => {
        throw error;
      });
  }

  static async deleteUnreadsMessages() {
    const { accessToken } = store.getState().MessengerSlice.data;
    const { tokkoMessengerURL } = store.getState().UserPreferencesSlice;
    return fetch(`${tokkoMessengerURL}/users/me/unreads`, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => data)
      .catch((error) => {
        throw error;
      });
  }

  static async duplicateContacts({
    webContactID,
    prioritizeOwnContacts = false,
  } = {}) {
    const composedURL = `/api3/marketing/webcontact/duplicate_contacts_by_web_contact?web_contact_id=${webContactID}&prioritize_own_contacts=${prioritizeOwnContacts}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async messengerManager(data) {
    const composedURL = `/api3/webcontact/messenger_manager`;
    const response = await ApiService.post(composedURL, data);
    return response;
  }

  static async getAgentsChat({ q = '', page = '' } = {}) {
    let composedURL = '/api3/agent?only_actives=true';
    const params = [];

    if (q) {
      params.push(`q=${encodeURIComponent(q)}`);
    }

    if (page) {
      params.push(`page=${page}`);
    }

    if (params.length > 0) {
      composedURL += `?${params.join('&')}`;
    }

    const response = await ApiService.get(composedURL);
    return response;
  }

  static async deleteWebcontact({ webcontactId = '' } = {}) {
    const composedURL = `/marketing/delete_webcontact?webcontact_id=${encodeURIComponent(
      webcontactId
    )}`;

    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getPropertiesToShare(data) {
    const { q, page } = data;
    let composedURL = '/api3/property';
    const params = [];

    if (q) {
      params.push(`q=${encodeURIComponent(q)}`);
    }

    if (page) {
      params.push(`page=${page}`);
    }

    if (params.length > 0) {
      composedURL += `/?${params.join('&')}`;
    }
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getDevelopmentsToShare(data) {
    const { q, page } = data;
    let composedURL = '/api3/developments';
    const params = [];

    if (q) {
      params.push(`searchword=${encodeURIComponent(q)}`);
    }

    if (page) {
      params.push(`page=${page}`);
    }

    if (params.length > 0) {
      composedURL += `?${params.join('&')}`;
    }

    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getStarredsForEntity(data) {
    const { contactId, entityType } = data;
    const composedURL = `/api3/contact/${contactId}/starreds_for?entity=${entityType}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getContact(id) {
    const composedURL = `/api3/contact/?id=${id}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getContactNotes({ contactId, limit = 10, offset = 0 } = {}) {
    const composedURL = `/api3/contacts/${contactId}/notes/?limit=${limit}&offset=${offset}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getContactInquiries({
    contactId,
    limit = 10,
    offset = 0,
    channelId = '',
    channelType = '',
  } = {}) {
    const params = new URLSearchParams({
      limit: String(limit),
      offset: String(offset),
    });
    if (channelId) params.set('channel_id', channelId);
    if (channelType) params.set('channel_type', channelType);
    const composedURL = `/api3/contacts/${contactId}/inquiries/?${params.toString()}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  // `skipTransientRetry`: this endpoint answers a permission failure with 500, so the
  // generic 5xx retry would fire three requests for a contact the user can never read.
  static async getContactTags(contactId) {
    const composedURL = `/api3/contact/${contactId}/tags/`;
    const response = await ApiService.get(composedURL, undefined, false, true);
    return response;
  }

  static async getLeadsStatus() {
    const composedURL = '/api3/contact/leads_status';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async changeLeadStatus(data) {
    const composedURL = '/api3/contacts/set_lead_status';
    const body = { ids: [data.id], lead_status_id: data.body.lead_status };
    const response = await ApiService.post(composedURL, body);
    return response;
  }

  static async getFichaInfoUrl(data) {
    const { id, contactId } = data;
    const composedURL = `/api3/property/get_ficha_info_url?properties_id=${id}&contact_id=${contactId}&is_edited=${true}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getWhatsappIsLinked({ branch_id } = {}) {
    let composedURL = `/api3/tokko_chat/whatsapp/is_linked`;

    if (branch_id) {
      composedURL += `?branch_id=${encodeURIComponent(branch_id)}`;
    }

    const response = await ApiService.get(composedURL);
    return response;
  }

  static async postCreateChannel(data) {
    const { accessToken } = store.getState().MessengerSlice.data;
    const { tokkoMessengerURL } = store.getState().UserPreferencesSlice;

    return fetch(
      `${tokkoMessengerURL}/users/me/channel/one_to_one/get_or_create`,
      {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify(data),
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .catch((error) => {
        throw error;
      });
  }

  static async deleteMessage(data) {
    const { accessToken } = store.getState().MessengerSlice.data;
    const { tokkoMessengerURL } = store.getState().UserPreferencesSlice;

    return fetch(`${tokkoMessengerURL}/users/me/message`, {
      method: 'DELETE',
      credentials: 'include',
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .catch((error) => {
        throw error;
      });
  }

  static async desynchronizeWhatsapp({ instance_id } = {}) {
    const { accessToken } = store.getState().MessengerSlice.data;
    const { tokkoMessengerURL } = store.getState().UserPreferencesSlice;

    return fetch(
      `${tokkoMessengerURL}/users/whatsapp/desynchronize?instance_id=${instance_id}`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .catch((error) => {
        throw error;
      });
  }

  static async sendWhatsappMessage(data) {
    const { accessToken } = store.getState().MessengerSlice.data;
    const { tokkoMessengerURL } = store.getState().UserPreferencesSlice;

    return fetch(`${tokkoMessengerURL}/users/whatsapp/message/send`, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .catch((error) => {
        throw error;
      });
  }

  static async getBranches({ hasWhatsapp = false } = {}) {
    const composedURL = hasWhatsapp
      ? `/api3/company/branch?has_whatsapp=true`
      : `/api3/company/branch`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async patchBranchPhone(data) {
    const composedURL = `/api3/company/branch`;
    const response = await ApiService.patch(composedURL, data);
    return response;
  }

  static async getTokkiSummary({ channelId, channelType, agentId }) {
    const { accessToken } = store.getState().MessengerSlice.data;
    const { tokkoMessengerURL } = store.getState().UserPreferencesSlice;

    const composedURL = `${tokkoMessengerURL}/tokki/summary?channel_id=${channelId}&channel_type=${channelType}&agent_id=${agentId}`;
    return fetch(composedURL, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .catch((error) => {
        throw error;
      });
  }

  static async postContactProfileSummaryFeedback(data) {
    const composedURL = `/api3/contacts/${data.contact_id}/profile_summary/feedback`;
    // noRedirect = true para evitar logout automático si Tokki falla
    const response = await ApiService.post(
      composedURL,
      data,
      undefined,
      false,
      true
    );
    return response;
  }

  // POST tokki message feedback
  static async postTokkiMessageFeedback(data) {
    const { accessToken } = store.getState().MessengerSlice.data;
    const { tokkoMessengerURL } = store.getState().UserPreferencesSlice;

    return fetch(`${tokkoMessengerURL}/tokki/chat_summary_feedback`, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .catch((error) => {
        throw error;
      });
  }

  static async getContactProfileSummary(contactId) {
    const composedURL = `/api3/contacts/${contactId}/profile_summary`;
    // noRedirect = true para evitar logout automático si Tokki falla
    const response = await ApiService.get(composedURL, undefined, true);
    return response;
  }

  static async postContactNoteWithAgent(data) {
    const composedURL = `/api3/contact/note_with_agent/`;
    const response = await ApiService.post(composedURL, data);
    return response;
  }

  static async getContactChatOrSender(contactId, data) {
    const response = await ApiService.post(
      `/api3/tokko_chat/${contactId}/chat_or_sender`,
      data
    );
    return response;
  }

  static async uploadAudioMessage(formData) {
    const { accessToken } = store.getState().MessengerSlice.data;
    const { tokkoMessengerURL } = store.getState().UserPreferencesSlice;

    return fetch(`${tokkoMessengerURL}/media/audio_upload`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .catch((error) => {
        throw error;
      });
  }

  static async getChannels({
    scope,
    filter,
    platform,
    agent_id,
    page = 1,
    limit = 10,
  } = {}) {
    const params = new URLSearchParams();

    if (agent_id) params.append('agent_id', agent_id.toString());
    if (scope) params.append('scope', scope);
    if (filter) params.append('filter', filter);
    if (platform) params.append('platform', platform);

    params.append('page', page.toString());
    params.append('limit', limit.toString());

    const composedURL = `/api3/tokko_chat/channels?${params.toString()}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getChannelReplyCapability({
    channelId,
    channelType,
    leadPhone,
    companyId,
  }) {
    const { accessToken } = store.getState().MessengerSlice.data;
    const { tokkoMessengerURL } = store.getState().UserPreferencesSlice;

    return fetch(`${tokkoMessengerURL}/users/me/channel/reply-capability`, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({
        channel_id: channelId,
        channel_type: channelType,
        lead_phone: leadPhone,
        company_id: companyId,
      }),
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .catch((error) => {
        throw error;
      });
  }

  static async getWhatsAppTemplates() {
    const { accessToken } = store.getState().MessengerSlice.data;
    const { tokkoMessengerURL } = store.getState().UserPreferencesSlice;

    return fetch(`${tokkoMessengerURL}/templates`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .catch((error) => {
        throw error;
      });
  }

  static async sendRenderedTemplateMessage({
    templateId,
    channelId,
    channelType,
    leadPhone,
    contactId,
    webContactId,
    companyId,
    propertyId,
  }) {
    const { accessToken } = store.getState().MessengerSlice.data;
    const { tokkoMessengerURL } = store.getState().UserPreferencesSlice;

    return fetch(
      `${tokkoMessengerURL}/templates/${templateId}/rendered-message`,
      {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
          channel_id: channelId,
          channel_type: channelType,
          lead_phone: leadPhone,
          contact_id: contactId,
          web_contact_id: webContactId,
          company_id: companyId,
          property_id: propertyId,
        }),
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }
    )
      .then(async (response) => {
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) {
          const error = new Error(
            payload?.detail?.message ||
              payload?.detail ||
              'Failed to send rendered template message'
          );
          error.payload = payload;
          throw error;
        }
        return payload;
      })
      .catch((error) => {
        throw error;
      });
  }

  static async blockChannel({ cellphone, notes }) {
    const composedURL = `/api3/tokko_chat/numbers/blacklist`;
    const response = await ApiService.post(composedURL, { cellphone, notes });
    return response;
  }

  static async unblockChannel({ cellphone }) {
    const composedURL = `/api3/tokko_chat/numbers/blacklist`;
    const response = await ApiService.delete(composedURL, { cellphone });
    return response;
  }

  static async acceptChannel({ channel_id }) {
    const composedURL = `/api3/tokko_chat/channel/accept`;
    const response = await ApiService.post(composedURL, { channel_id });
    return response;
  }

  static async searchChat({ q = '', page = 1, limit = 20 } = {}) {
    const params = new URLSearchParams();

    if (q) {
      params.append('q', q);
    }

    params.append('page', page.toString());
    params.append('limit', limit.toString());
    params.append('only_my_contacts', 'true');

    const composedURL = `/api3/tokko_chat/search?${params.toString()}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getBlockedChannels({ page = 1, limit = 10 } = {}) {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('limit', limit.toString());
    const composedURL = `/api3/tokko_chat/numbers/blacklist?${params.toString()}`;
    const response = await ApiService.get(composedURL);
    return response;
  }
}

export default MessengerService;
